import React,{useState} from 'react';
import './FriedItems.css'
import FriedItemsDisplay from './FriedItemsDisplay';


const FriedItems = ({title}) => {
    const [clicked, setclicked] = useState(false);
    return <div className= "FriedItems_container">
        <div className="Fried_container">
        <h2>{title}</h2>  
        <button onClick={()=>{
            setclicked(!clicked) 
        }}>{clicked?'-':'+'}</button>  
        </div><br/>
      {clicked?<FriedItemsDisplay type={title}/>:null}
    
    </div>;
}
 
export default FriedItems;